// extracted by mini-css-extract-plugin
export default {"root":"role_information-module___root___da4c8c13","bookingCategory":"role_information-module___bookingCategory___bf9ecaf2","pill":"role_information-module___pill___a7641b13"};